(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class DesktopNavInputMode {
    constructor() {
      this.root = document.documentElement;
      this.navSelector = '.dia-header-nav';
      if (!document.querySelector(this.navSelector)) return;
      document.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        this.root.classList.add('dia-touch-input');
        if (!event.target.closest(this.navSelector)) {
          const focusedElement = document.activeElement;
          if (focusedElement?.closest(this.navSelector)) focusedElement.blur();
        }
      }, true);
      document.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse') this.root.classList.remove('dia-touch-input');
      }, { passive: true });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new DesktopNavInputMode());
  /* Desktop nav: hover opens dropdown, click/tap navigates to category page. Touch-first: tap = navigate, don not open dropdown. */
  class NavClickHandler {
    constructor() {
      this.isTouching = false;
      this.init();
    }
    init() {
      const summaries = document.querySelectorAll(".header__inline-menu summary[data-href]");
      summaries.forEach((summary) => {
        summary.addEventListener("touchstart", () => { this.isTouching = true; }, {passive: true});
        summary.addEventListener("click", (e) => {
          if (window.innerWidth < 990) return;
          const href = summary.getAttribute("data-href");
          if (!href) return;
          // Touch: always navigate on tap, don not toggle dropdown
          if (this.isTouching) {
            e.preventDefault();
            e.stopPropagation();
            this.isTouching = false;
            window.location.href = href;
            return;
          }
          // Mouse: navigate on first click (menu closed), toggle on second click (menu open)
          if (!summary.closest("details").hasAttribute("open")) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = href;
          }
        });
        summary.addEventListener("mouseup", () => { this.isTouching = false; });
      });
    }
  }
  document.addEventListener("DOMContentLoaded", () => new NavClickHandler());

  } catch(e) { console.error(e); }
})();
})();
